// extracted by mini-css-extract-plugin
module.exports = {"topArticlesRoot":"TopArticles_topArticlesRoot__uuWuG","title":"TopArticles_title__VTU_t","article":"TopArticles_article__KMejR"};